<template>
    <div class="modal" :class="current.type" v-if="visible" v-cloak>
        <span class="close-button" @click="dismiss"><i class="fas fa-times"></i></span>
        <div class="container" v-html="current.body"></div>
    </div>
</template>
<script>
    import AjaxCaller from '../../mixins/AjaxCaller';
    import RequestErrorHandler from '../../mixins/RequestErrorHandler';
    export default {
        mixins: [AjaxCaller, RequestErrorHandler],
        props: {
            id: {
                required: false
            },
            preventBackgroundScrolling: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                visible: false,
                current: {},
                collection: {},
            }
        },
        created() {

            EventHandler.listen('toggle-modal', this.fetch);

            const escapeHandler = event => {
                if (event.key === 'Escape' && this.visible) {
                    this.dismiss()
                }
            };

            document.addEventListener('keydown', escapeHandler);

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', escapeHandler);
            });
        },
        mounted() {
            this.initialize();

            let modals = document.getElementsByClassName('reveal-modal');

            if (modals.length === 0) {
                return;
            }

            [...modals].forEach(modal => {
                modal.onclick = event => {
                    this.fetch(event.currentTarget.getAttribute('data-modal-id'));
                    this.dispatchEvent(true);
                }
            });
        },
        watch: {
            current: {
                immediate: true,
                handler(newValue) {
                    this.visible = Object.keys(newValue).length > 0;
                    this.toggleBackgroundScrolling();
                }
            }
        },
        methods: {
            initialize() {
                if (this.id) {
                    this.fetch(this.id);
                }
            },
            toggleBackgroundScrolling() {
                if (!this.preventBackgroundScrolling) {
                    return;
                }
                if (this.visible) {
                    document.body.style.setProperty('overflow', 'hidden');
                } else {
                    document.body.style.removeProperty('overflow');
                }
            },
            fetch(id) {
                this.dismiss();
                if (this.collection.hasOwnProperty(id)) {
                    this.current = this.collection[id];
                    return;
                }
                this.makeRequest(
                    response => {
                        this.requestSuccess(response, id)
                    },
                    this.requestFailure,
                    {id}
                );
            },
            requestSuccess(response, id) {
                if (!response.data.body) {
                    return;
                }
                this.collection[id] = this.current = {
                    type: response.data.type,
                    body: response.data.body
                };
            },
            dismiss() {
                this.current = {};
                this.dispatchEvent(false);
            },
            dispatchEvent(visible) {
                EventHandler.fire('modal-toggled', { visible });
            }
        }
    }
</script>